<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>
    <table class="table table-bordered" style="color:#9b7544" border="1">
       <thead>
            <td> Type</td>
            <td> Fees</td>  
       </thead>
       <tbody>
            <tr>
                    <td>{{text}}</td>   
                    <td>{{fees1}}</td>
                   </tr> 
                   <tr>
                         <td>{{video}}</td>   
                         <td>{{fees2}}</td>
                        </tr> 
       </tbody>
    </table>
    <p>
            <mat-radio-group [(ngModel)]="chattype"> Select Chat Type
                <mat-radio-button value="text">Text Chat</mat-radio-button>
                <mat-radio-button value="video">Video Chat</mat-radio-button>
              </mat-radio-group>
        </p>
   <p>
        <mat-radio-group [(ngModel)]="gateway"> Select payment gateway
            <mat-radio-button value="raz">Razorpay</mat-radio-button>
           <!-- <md-radio-button value="ebs">EBS</md-radio-button> -->
          </mat-radio-group>
    </p> 
    <div class="row">
        <div class="col-6 center text-center">
            <button *ngIf="gateway ==='raz' && chattype; else ebs" class="btn btn-success3" (click)="goForChat(1)">Confirm</button>
        </div>
        <div class="col-6 center text-center">
            <button  class="btn btn-success" mat-dialog-close>Cancel</button>  
        </div>
    </div>
  <ng-template #ebs>
      
        <form #form *ngIf="gateway==='ebs'"  method="post" 
        action="https://secure.ebs.in/pg/ma/payment/request"  >
        <input type="hidden" value="18371" name="account_id"/>
            <input type="hidden" value="Sarjapur Road" name="address"/>
            <input type="hidden"  value="500" name="amount"/>
            <input type="hidden" value="" name="bank_code"/>
            <input type="hidden" value="" name="card_brand"/>
            <input type="hidden"  value="0" name="channel"/>
            <input type="hidden" value="Banglore" name="city"/>
            <input type="hidden" value="IND" name="country"/>
            <input type="hidden" value="INR" name="currency"/>
            <input type="hidden" value="Chat Booking" name="description"/>
            <input type="hidden" value="INR" name="display_currency"/>
            <input type="hidden" value="" name="display_currency_rates"/>
            <input type="hidden" value="rakshitmonojit@gmail.com" name="email"/>
            <input type="hidden" value="" name="emi"/>
            <input type="hidden" value="TEST" name="mode"/>
            <input type="hidden"  value="Monojit Rakshit" name="name"/>
            <input type="hidden" value="" name="page_id"/>
            <input type="hidden" value="" name="payment_mode"/>
            <input type="hidden" value="" name="payment_option"/>
            <input type="hidden"  value="7908657412" name="phone"/>
            <input type="hidden" value="562125" name="postal_code"/>
            <input type="hidden" value="123" name="reference_no"/>
            <input type="hidden" value="https://www.petcart.com"  name="return_url"/>
            <input type="hidden" value="" name="ship_address"/>
            <input type="hidden" value="" name="ship_city"/>
            <input type="hidden" value="" name="ship_country"/>
            <input type="hidden" value="" name="ship_name"/>
            <input type="hidden" value="" name="ship_phone"/>
            <input type="hidden" value="" name="ship_postal_code"/>
            <input type="hidden" value="" name="ship_state"/>
            <input type="hidden"  value="karnataka" name="state"/>
            <input type="hidden"  value="0E2177D96FBB3D6A00BA2916A017EE48" name="secure_hash"/>
            <button (click)="submitForm()"> SUBMIT </button>      
            </form>
  </ng-template>
   


        
        
        
        
        
        
        